import React from 'react';

const LoadingMatchup = () => {
  return (
    <div className="absolute inset-0 flex items-center justify-center bg-background/80 backdrop-blur-sm z-20">
      <div className="relative">
        {/* Outer circle */}
        <div className="w-24 h-24 rounded-full border-4 border-brand/20 animate-[spin_3s_linear_infinite]">
          {/* Inner circle */}
          <div className="absolute inset-1 rounded-full border-4 border-brand animate-[spin_2s_linear_infinite_reverse]">
            {/* Center circle */}
            <div className="absolute inset-2 rounded-full bg-brand/10 flex items-center justify-center">
              <span className="text-brand text-sm font-medium">Loading</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingMatchup;